import { axiosInstance } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    positions: [],
    departments: [],
    companyDepartments: [],
    leadsStatus: [],
    leads: [],
    plans: [],
    companies: [],
    companyPlans: [],
    hasPlanActive: {},
    companyNumberOfCollaborators: null,
    companyAdmins: [],
    companyProfessionals: [],
    companyProfessionalDetails: {},
    companyFilterActive: "work-in-company",
    companyCollaborators: [],
  },
  getters: {
    positions(state) {
      return state.positions;
    },
    departments(state) {
      return state.departments;
    },
    companyDepartments(state) {
      return state.companyDepartments;
    },
    leadsStatus(state) {
      return state.leadsStatus;
    },
    leads(state) {
      return state.leads;
    },
    plans(state) {
      return state.plans;
    },
    companies(state) {
      return state.companies;
    },
    companyPlans(state) {
      return state.companyPlans;
    },
    hasPlanActive(state) {
      return state.hasPlanActive;
    },
    companyNumberOfCollaborators(state) {
      return state.companyNumberOfCollaborators;
    },
    companyAdmins(state) {
      return state.companyAdmins;
    },
    companyProfessionals(state) {
      return state.companyProfessionals;
    },
    companyProfessionalDetails(state) {
      return state.companyProfessionalDetails;
    },
    companyFilterActive(state) {
      return state.companyFilterActive;
    },
    companyCollaborators(state) {
      return state.companyCollaborators;
    },
  },
  mutations: {
    SET_POSITIONS(state, value) {
      state.positions = value;
    },
    SET_DEPARTMENTS(state, value) {
      state.departments = value;
    },
    SET_COMPANY_DEPARTMENTS(state, value) {
      state.companyDepartments = value;
    },
    SET_LEADS_STATUS(state, value) {
      state.leadsStatus = value;
    },
    SET_LEADS(state, value) {
      state.leads = value;
    },
    SET_PLANS(state, value) {
      state.plans = value;
    },
    SET_COMPANIES(state, value) {
      state.companies = value;
    },
    SET_COMPANY_PLANS(state, value) {
      state.companyPlans = value;
    },
    SET_HAS_PLAN_ACTIVE(state, value) {
      state.hasPlanActive = value;
    },
    SET_COMPANY_NUMBER_OF_COLLABORATORS(state, value) {
      state.companyNumberOfCollaborators = value;
    },
    SET_COMPANY_ADMINS(state, value) {
      state.companyAdmins = value;
    },
    SET_COMPANY_PROFESSIONALS(state, value) {
      state.companyProfessionals = value;
    },
    SET_COMPANY_PROFESSIONAL_DETAILS(state, value) {
      state.companyProfessionalDetails = value;
    },
    SET_COMPANY_FILTER_ACTIVE(state, value) {
      state.companyFilterActive = value;
    },
    SET_COMPANY_COLLABORATORS(state, value) {
      state.companyCollaborators = value;
    },
  },
  actions: {
    async registerPositions(context, value) {
      const url = value?.id
        ? `company/positions/${value.id}`
        : "company/positions";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultPositions");
        });
    },
    async consultPositions(context, value) {
      const url = value?.id
        ? `company/positions/${value.id}`
        : "company/positions";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_POSITIONS", data]);
    },
    async removePosition(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/positions/${id}`,
      });

      context.dispatch("consultPositions");
    },
    async registerDepartments(context, value) {
      const url = value?.id
        ? `company/departments/${value.id}`
        : "company/departments";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultDepartments");
        });
    },
    async consultDepartments(context, value) {
      const url = value?.id
        ? `company/departments/${value.id}`
        : "company/departments";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_DEPARTMENTS", data]);
    },
    async consultCompanyDepartments(context, idCompany) {
      const { data } = await axiosInstance({
        method: "GET",
        url: `company/${idCompany}/companyDepartments`,
      });

      context.dispatch("setDataDefault", ["SET_COMPANY_DEPARTMENTS", data]);
    },
    async removeDepartment(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/departments/${id}`,
      });

      context.dispatch("consultDepartments");
    },
    async registerLeadsStatus(context, value) {
      const url = value?.id
        ? `company/leadsStatus/${value.id}`
        : "company/leadsStatus";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultLeadsStatus");
        });
    },
    async consultLeadsStatus(context, value) {
      const url = value?.id
        ? `company/leadsStatus/${value.id}`
        : "company/leadsStatus";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_LEADS_STATUS", data]);
    },
    async removeLeadStatus(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/leadsStatus/${id}`,
      });

      context.dispatch("consultLeadsStatus");
    },
    async saveLeads(context, value) {
      const url = value?.id ? `company/leads/${value.id}` : "company/leads";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultLeads");
        });
    },
    async consultLeads(context, value) {
      const url = value?.id ? `company/leads/${value.id}` : "company/leads";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_LEADS", data]);
    },
    async registerPlan(context, value) {
      const url = value?.id ? `company/plans/${value.id}` : "company/plans";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultPlans");
        });
    },
    async consultPlans(context, value) {
      const url = value?.id ? `company/plans/${value.id}` : "company/plans";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_PLANS", data]);
    },
    async removePlan(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/plans/${id}`,
      });

      context.dispatch("consultPlans");
    },
    async registerCompany(context, value) {
      const url = value?.id ? `company/${value.id}` : "company";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultCompanies");
        });
    },
    async consultCompanies(context, value) {
      const url = value?.id ? `company/${value.id}` : "company";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_COMPANIES", data]);
    },
    async removeCompany(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/${id}`,
      });

      context.dispatch("consultCompanies");
    },
    async registerCompanyPlan(context, value) {
      const url = value?.id
        ? `company/${value.id_company}/hasPlans/${value.id}`
        : `company/${value.id_company}/hasPlans`;

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          const payload = { id: value.id_company };
          context.dispatch("consultCompanyPlans", payload);
        });
    },
    async consultCompanyPlans(context, value) {
      const url = value?.idCompanyHasPlan
        ? `company/${value.id}/hasPlans/${value.idCompanyHasPlan}`
        : `company/${value.id}/hasPlans`;

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_COMPANY_PLANS", data]);
    },
    async registerCompanyAdmin(context, value) {
      const url = value?.id
        ? `company/${value.id_company}/companyAdmin/${value.id}`
        : `company/${value.id_company}/companyAdmin`;

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          const payload = { id: value.id_company };
          context.dispatch("consultCompanyAdmins", payload);
        });
    },
    async consultCompanyAdmins(context, value) {
      const url = value?.idCompanyAdmin
        ? `company/${value.id}/companyAdmin/${value.idCompanyAdmin}`
        : `company/${value.id}/companyAdmin`;

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_COMPANY_ADMINS", data]);
    },
    async updateCompanyProfessional(context, value) {
      const url = value?.id
        ? `company/${value.id_company}/hasProfessional/${value.id}`
        : `company/${value.id_company}/hasProfessional`;

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      });
    },
    async consultCompanyProfessionals(context, value) {
      const url = value?.idCompanyHasProfessional
        ? `company/${value.id}/hasProfessional/${value.idCompanyHasProfessional}`
        : `company/${value.id}/hasProfessional`;

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_COMPANY_PROFESSIONALS", data]);
    },
    async consultCompanyProfessionalDetails(context, value) {
      const url = `company/${value.id}/professional/${value.idProfessional}/details`;

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", [
        "SET_COMPANY_PROFESSIONAL_DETAILS",
        data,
      ]);
    },
    async registerCompanyCollaborator(context, value) {
      const url = value?.id
        ? `company/${value.id_company}/companyCollaborator/${value.id}`
        : `company/${value.id_company}/companyCollaborator`;

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          const payload = { id: value.id_company };
          context.dispatch("consultCompanyCollaborators", payload);
        });
    },
    async consultCompanyCollaborators(context, value) {
      const url = value?.idCompanyCollaborator
        ? `company/${value.id}/companyCollaborator/${value.idCompanyCollaborator}`
        : `company/${value.id}/companyCollaborator`;

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_COMPANY_COLLABORATORS", data]);
    },
    async updateProfessionalHasCompanyCollaborators(context, value) {
      const url = value?.id
        ? `company/${value.id_company}/${value.id_professional}/hasCompanyCollaborators/${value.id}`
        : `company/${value.id_company}/${value.id_professional}/hasCompanyCollaborators`;

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      });

      const payload = {
        id: value.id_company,
        idProfessional: value.id_professional,
      };
      context.dispatch("consultCompanyProfessionalDetails", payload);
    },
    async resendEmailRegisterCompanyAdmin(context, value) {
      const url = `company/${value.id_company}/companyAdmin/${value.id}/resendEmailRegister`;

      return await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      });
    },
    async resendEmailRegisterCompanyCollaborator(context, value) {
      const url = `company/${value.id_company}/companyCollaborator/${value.id}/resendEmailRegister`;

      return await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      });
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
  },
};
